<template>
  <div>
    <div class="form-group">
      <p class="info-text">
        <i class="fas fa-info-circle mr-2"></i>This report shows all active carryovers for your firm.
      </p>
    </div>

    <div class="button-group">
      <button type="button" class="btn btn-outline-secondary action-button" @click="generateReport">
        <i class="fas fa-download mr-2"></i>Download Report
      </button>
    </div>
  </div>
</template>

<script>
import { Api } from "./../../../factory";
import { alert } from "./../../../service";

export default {
  data() {
    return {};
  },
  methods: {
    async generateReport() {
      try {
        const { data } = await Api.post("reports/firm-carryovers", {});
        this.downloadCSV(data);
      } catch (err) {
        alert.error(`Error generating report: ${err.message}`);
      }
    },
    downloadCSV(data) {
      if (!data || !data.csvContent || !data.fileName) {
        alert.error("Invalid CSV data");
        return;
      }

      const binaryString = window.atob(data.csvContent);
      const bytes = new Uint8Array(binaryString.length);
      for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }

      const blob = new Blob([bytes], { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = data.fileName;
      link.click();
      window.URL.revokeObjectURL(url);
    }
  }
};
</script>

<style scoped>
.form-group {
  margin-bottom: 20px;
}

.info-text {
  padding: 12px;
  background-color: #e3f2fd;
  border-left: 4px solid #2196f3;
  color: #1565c0;
  margin: 0;
  border-radius: 4px;
  font-size: 14px;
}

.button-group {
  display: flex;
  justify-content: center;
  margin-top: 30px;
}

.action-button {
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
</style>
